'use strict';

var $ = require('jquery');
var analytics = require('../utils/analytics');

var trimAutoSelected = false;

var classNames = {
	trimEquipmentList: 'trim-equipment-list',
	trimNextStep: 'trim-next-step'
};

var modifiers = {
	nextStepDisabled: 'next-step--disabled'
};

var $trimLevelsDropdown;

var trimSelectCount = 0;

function trackTrimSelectEvent() {
	trimSelectCount++;
	analytics.trackEvent('Car Specs Model', 'Trim Selected ' + trimSelectCount, window.parkersConfig.dataLayer.vehicle.vehicleName);
}


module.exports = {
	init: function ($context, displayEngineDropDown, actionTrimSelectedEvent) {
		$trimLevelsDropdown = $.findByBem(classNames.trimEquipmentList, 'filter', null, $context);
		if ($trimLevelsDropdown.length > 0) {
			$trimLevelsDropdown.off('change.equipmentList').on('change.equipmentList', function () {
				var selectedTrim = $trimLevelsDropdown.val();
				if (selectedTrim === '') {
					$.findByBem(classNames.trimEquipmentList, 'by-trim', null, $context).hide();
					$.findByBem(classNames.trimEquipmentList, 'optional', null, $context).fadeIn();
				} else {
					$.findByBem(classNames.trimEquipmentList, 'optional', null, $context).hide();
					$.findByBem(classNames.trimEquipmentList, 'by-trim', null, $context).hide().filter('[data-trim-id="' + selectedTrim + '"]').fadeIn();

					if (actionTrimSelectedEvent && selectedTrim !== 'placeholder' && !trimAutoSelected) {
						trackTrimSelectEvent();
					}
					else {
						trimAutoSelected = false;
					}

					if (displayEngineDropDown) {
						$.findByBem(classNames.trimNextStep).toggleClass(modifiers.nextStepDisabled, selectedTrim === 'placeholder');

						var $engineDropDown = $('[data-engine-trim-id="' + selectedTrim + '"]');
						$engineDropDown.trigger('display', selectedTrim);
					}
				}
			});
		}
	},

	autoSelectSingleTrim: function () {
		if ($trimLevelsDropdown.length > 0) {
			var numberOfOptions = $trimLevelsDropdown[0].length;
			var singleOption = 2;

			if (numberOfOptions === singleOption) {
				$trimLevelsDropdown[0].value = 'trim_1';
				$trimLevelsDropdown.trigger('change.equipmentList');
			}
		}
	},

	autoSelectAssignedTrim: function () {
		if ($trimLevelsDropdown.length && $trimLevelsDropdown[0].selectedIndex > 0) {
			trimAutoSelected = true;
			$trimLevelsDropdown.trigger('change.equipmentList');
		}
	}
};